<template>
  <div class="Staff_index base">
    <cursor-fx ref="cursor" />  
    <section id="load_grid"></section>
    <section id="white_lay"></section>
    <section id="black_lay"></section>
	  <section id="op_base" class="flex_wrapper">
      <div class="catche">
        <p class="one" ref="abc">{{attr_1}}</p>
        <p class="two">{{attr_2}}</p>
      </div>
      <div class="m-mv__main__scroll js-opening-scroll">
	      <div class="c-scroll-down js-scroll" data-scroll="#main">
		      <span class="txt">Scroll</span><span class="line"></span>
	      </div>
      </div>
    </section>
    <section id="op_stage">
      <div class="bg_mv_cov">
        <canvas class="canvas-container"></canvas>
        <div></div>
      </div>
    </section>
    <section class="under_wrapper bg_type_1">
      <section class="under_top sec_pad_1 lo_right">
        <article class="flex_wrapper bxs anim_tgt defo_ua">
          <div class="tx bx">
            <h2 class="h_type_1 jp">
              テキスト／テキスト／<br>
              テキスト／テキスト／<br class="sp">テキスト／テキスト。
            </h2>
            <p>
              テキスト／テキスト／テキスト／テキスト／<br>
              テキスト／テキスト。<br><br>
              <span class="b">
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／
              </span><br><br>
              テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。
            </p>
          </div>
          <div class="px bx"></div>
        </article> 
      </section>
      <section class="sec_pad_1_b lo_left">
        <article class="flex_wrapper bxs anim_tgt up_fade">
          <div class="px bx"></div>
          <div class="tx bx">
            <h2 class="h_type_1 jp">
              テキスト／テキスト／<br>
              テキスト／テキスト／テキスト／テキスト。
            </h2>
            <p>
              テキスト／テキスト／テキスト／テキスト／<br>
              テキスト／テキスト。<br><br>
              <span class="b">
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／<br>
              -テキスト／テキスト／テキスト／テキスト／
              </span><br><br>
              テキスト／テキスト／テキスト／テキスト／テキスト／テキスト。
            </p>
          </div>
        </article> 
      </section>
      <section class="mid_bg">
        <p>
           {{attr_3}}
        </p>
      </section>


    </section>      
  </div>
</template>
<script>
// @ is an alias to /src
import { TweenMax, TimelineMax } from 'gsap';
import { under_op } from "@/js/under_op.js";
import { header_fix } from '@/js/header_fix.js';
import { particle } from '@/js/particle.js';
import { bg_mv } from '@/js/bg_mv.js';
import { scroll_anim } from '@/js/scroll_anim.js';
import { common } from '@/js/common.js';
export default {
  name: 'Staff_index',
  props: { id: Number },
  data() {
    return {
         attr_1: '役職',   
         attr_2: '名前',
         attr_3: 'メッセージ'
    }
  },
  mounted() {
    const timeline = new TimelineMax(); 
    const wh = window.innerWidth; 
    //TweenMax.set('.bg_mv_cov', { width: '0%' });
    let pam_id = this.$route.params.id;
    if( pam_id == 0 ){
      this.attr_1 = '代表取締役CEO';
      this.attr_2 = '山田 山一';
      this.attr_3 = `山田 山一のメッセージ／メッセージ
      メッセージ／メッセージ`
    }
    else if( pam_id == 1 ){
      this.attr_1 = '取締役副社長COO';
      this.attr_2 = '君島 君恵';
      this.attr_3 = `君島 君恵のメッセージ／メッセージ
      メッセージ／メッセージ`
    }
    else if( pam_id == 2 ){
      this.attr_1 = '執行役員CMO';
      this.attr_2 = '巌 岩男';
      this.attr_3 = `巌 岩男のメッセージ／メッセージ
      メッセージ／メッセージ`
    }
    else if( pam_id == 3 ){
      this.attr_1 = '社外監査役';
      this.attr_2 = '御厨 美玖';
      this.attr_3 = `御厨 美玖のメッセージ／メッセージ
      メッセージ／メッセージ`
    }
    
    under_op(timeline, wh);
    header_fix();
    particle('.bg_mv_cov','.canvas-container'); 
    bg_mv();
    let scrollElem = document.querySelectorAll('.anim_tgt');
    scroll_anim(scrollElem);
    let tgt = document.querySelector(".switchWrap"); 
    common(tgt);

    let add =  document.querySelector('.Staff_index');
    let this_path = this.$route.params['id'];
    console.log(this_path);
      if ( this_path == 0) {        
        add.classList.add('staff_0');
      } else if( this_path == 1){
        add.classList.add('staff_1');
      } else if( this_path == 2){
        add.classList.add('staff_2');
      } else if( this_path == 3){
        add.classList.add('staff_3');
      }

	this.$router.beforeEach((to, from, next) => {
        add.classList.remove('staff_0');
        add.classList.remove('staff_1');
        add.classList.remove('staff_2');
        add.classList.remove('staff_3');

        next()
  })

    document.body.className = 'under staff';
    this.$root.headerHide = true;
    this.$root.footerHide = true;
  },
  methods: {
    others() {
		  this.$refs.cursor.refresh();
    }
  },  
   beforeDestroy() {
    document.body.className = '';
    this.$root.headerHide = false;
    this.$root.footerHide = false;
  }
}
</script>